import {
  CreateResultLabelConceptMappingDocument,
  CreateResultLabelConceptMappingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateResultLabelConceptMapping = () => {
  const [createResultLabelConceptMapping, { loading }] = useMutation(
    CreateResultLabelConceptMappingDocument,
    {
      extractorFn: (data) => data.payrollMutations.createPayrollResultLabelConceptMapping,
    }
  )

  return {
    loading,
    create(variables: CreateResultLabelConceptMappingMutationVariables) {
      return createResultLabelConceptMapping({
        variables,
      })
    },
  }
}

export default useCreateResultLabelConceptMapping
